import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { AnalyticsEventMeta } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/analytics/types';

// eslint-disable-next-line jira/export/no-external-exports
export { setScrollingScrollTop as setStickyHeaderScroll } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/roadmap/sticky-header/actions';

export const VIEW_ROADMAP = 'command.roadmap.VIEW_ROADMAP' as const;

export type ViewRoadmapAction = {
	type: typeof VIEW_ROADMAP;
	meta: AnalyticsEventMeta;
};

export const viewRoadmap = (analyticsEvent: UIAnalyticsEvent): ViewRoadmapAction => ({
	type: VIEW_ROADMAP,
	meta: {
		analyticsEvent,
	},
});
